import { serializeSuperjson } from '@lib/superjson';
import {
  CreateConfiguredPartRequest,
  CreateConfiguredPartRequestParams,
  CreateConfiguredPartResponse,
} from '@snap-types/actions/create-configured-part';
import { buildSnapQuoteUrl } from '@ui/store/api-builder/build-url';
import { injectMutation } from '@ui/store/api-builder/inject-mutation';

export const [createConfiguredPart, useCreateConfiguredPartMutation] =
  injectMutation<
    CreateConfiguredPartRequestParams & CreateConfiguredPartRequest,
    CreateConfiguredPartResponse
  >('createConfiguredPart', ({ siteCode, snapQuoteUuid, ...rest }) => ({
    url: buildSnapQuoteUrl(siteCode, snapQuoteUuid, 'configured-part'),
    method: 'POST',
    body: serializeSuperjson(rest),
  }));
